import type { Route } from 'vue-router'
import { getMetaFromRoute } from '~/utility/route'
import { SearchFilters } from '../../search/schemas'
import { SearchFiltersUrl } from '../../url/search-filters/SearchFiltersUrl'
import * as campsiteFiltersUrlPart from '../../url/parts/campsiteFiltersUrlPart'
import { ensureArray } from '~/utility/array'
import {
  removeInvalidParams,
  removeUndefinedFields,
  routePathToQuery,
} from './utils'

// when you just need to get the filters from a route
export function routeToFilters(nextRoute: Route): SearchFilters {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- getMetaFromRoute returns untyped meta object from route config
  const meta = getMetaFromRoute(nextRoute)
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- nextRoute.query type from vue-router is LocationQuery with string | string[] values
  const nextQuery = nextRoute.query || {}
  const routePathQuery = routePathToQuery(nextRoute)

  const queries = {
    ...removeUndefinedFields(removeInvalidParams(nextQuery)),
    ...removeUndefinedFields(routePathQuery),
  }

  // Special handling for campsite detail pages - treat type params as route-based categories
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- nextRoute.name from vue-router is typed as string | symbol | undefined | null
  if (nextRoute.name === 'campsite-detail') {
    const typeParams = queries.type ? ensureArray(queries.type) : []

    // Get campsite filters with type params as routeBasedCategoryIds
    const campsiteFilters = campsiteFiltersUrlPart.fromQuery(
      { type: queries.type, facet: queries.facet },
      typeParams, // Pass type params as routeBasedCategoryIds
    )

    // Get other filters (excluding campsite filters to avoid double processing)
    const { type: _type, facet: _facet, ...otherQueries } = queries
    const otherFilters = SearchFiltersUrl.urlToFilters(otherQueries)

    const filters: SearchFilters = {
      ...otherFilters,
      ...campsiteFilters,
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- meta.type is untyped from route config
      base: meta.type,
    }

    // remove hierarchy path and base for non-search routes
    delete filters.hierarchyPath
    delete filters.base

    return filters
  }

  // Normal handling for search routes
  const filters: SearchFilters = {
    ...SearchFiltersUrl.urlToFilters(queries),
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- meta.type is untyped from route config
    base: meta.type,
  }

  return filters
}
